import type { PropsWithChildren } from 'react';

import { StoresContext, createStores } from './useStores';

export const StoreProvider = (props: PropsWithChildren) => {
  const stores = createStores();

  return <StoresContext.Provider value={stores}>{props.children}</StoresContext.Provider>;
};
